import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectDonateButtonLabel } from '../../features/campaign/campaignSlice';
import { FormattedMessage } from 'react-intl';

export const DonateNowButtonText = ({ donateButtonLabel }) => {
    return (
        donateButtonLabel || (
            <FormattedMessage
                id="DonateButton.text"
                defaultMessage="Donate Now!"
            />
        )
    );
};

const mapStateToProps = state => ({
    donateButtonLabel: selectDonateButtonLabel(state),
});

DonateNowButtonText.propTypes = {
    donateButtonLabel: PropTypes.string,
};

export default connect(mapStateToProps)(DonateNowButtonText);
